import {Menu} from "./classes/Menu.js";

document.addEventListener("DOMContentLoaded", () => {
    const menu = document.querySelector("#header .navigation .right");
    new Menu(menu);
})
